import { cn } from "./cn";

export interface CheckboxMarkProps {
  checked: boolean;
  /** Edge length in px. */
  size?: number;
  className?: string;
}

/**
 * Decorative checkbox glyph drawn in `currentColor`: a light filled square with
 * a tick when checked, a faint outline when not. Purely visual — the clickable
 * element around it owns the role / `aria-checked`.
 */
export function CheckboxMark({ checked, size = 16, className }: CheckboxMarkProps) {
  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      className={cn("shrink-0", className)}
    >
      <rect
        x="1"
        y="1"
        width="14"
        height="14"
        rx="3"
        fill={checked ? "currentColor" : "none"}
        stroke="currentColor"
        strokeWidth="1"
        strokeOpacity={0.45}
        fillOpacity={0.6}
      />
      {checked && (
        <path
          d="M4.5 8.2 7 10.5l4.5-5"
          fill="none"
          stroke="var(--surface)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  );
}
